import { Router, type CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStatus } from '../models';
import { TokenService } from '../services/token.service';

// Guard para proteger rutas, se ejecuta antes de activar la ruta
export const isAuthenticatedGuard: CanActivateFn = (route, state) => {
  const tokenService = inject(TokenService);  // Inyecta el servicio de autenticación
  const router = inject(Router);  // Inyecta el servicio de Router para navegar si es necesario

  // Verifica si el usuario está autenticado
  if(tokenService.authStatus() === AuthStatus.authenticated){
    return true;  // Permite el acceso a la ruta si está autenticado
  }

  // Verifica si la autenticación está en proceso
  if(tokenService.authStatus() === AuthStatus.checking){
    return false;  // No permite el acceso si el estado es 'checking'
  }

  // Redirige a la página de login si no está autenticado
  router.navigateByUrl('/sign-in');

  return false;  // Bloquea el acceso a la ruta si no está autenticado
};
